/**
 * Signature Pad Plugin
 */
(function ($) {

    "use strict";

    $.fn.signaturePad = function (options) {

        const $parent = $(this);

        const construct = {
            signatureInputField : null,
            signaturePad: null,
            previewImage: null,
            previousSignature: null,
            padInitialised: false,
            cancelSignatureButton: null,
            init : function () {
                let _this = this;
                _this.signatureInputField = $('#'+options.inputFieldId);
                _this.signaturePad = $($parent.find('.signature-pad-canvas-container')[0]);
                _this.signaturePreview = $($parent.find('.signature-preview')[0]);
                _this.previewImage = $($parent.find('.signature-preview img')[0]);
                _this.cancelSignatureButton = $($parent.find('.signature-pad-cancel')[0]);

                if (_this.signatureInputField.val() !== '') {
                    _this.previousSignature = _this.signatureInputField.val();
                    _this.hideSignaturePad();
                    _this.showSignaturePreview();
                } else {
                    _this.showSignaturePad();
                }

                _this.cancelSignatureButton.on('click', function($e) {
                    $e.preventDefault();
                    _this.clearSignature();
                    _this.signaturePad.hide();
                    _this.signaturePreview.show();
                    _this.signatureInputField.val(_this.previousSignature);
                });

                $parent.on('click', '.signature-pad-clear', function($e) {
                    $e.preventDefault();
                    _this.clearSignature();
                });

                $parent.on('click', '.signature-pad-change', function($e) {
                    $e.preventDefault();
                    _this.previousSignature = _this.signatureInputField.val();
                    _this.hideSignaturePreview();
                    _this.showSignaturePad();
                });

                return _this;
            },

            hideSignaturePad: function (){
                const _this = this;
                _this.signaturePad.hide();
            },

            hideSignaturePreview: function (){
                const _this = this;
                _this.signaturePreview.hide();
            },

            showSignaturePad: function () {
                const _this = this;

                if (_this.previousSignature) {
                    _this.cancelSignatureButton.show();
                } else {
                    _this.cancelSignatureButton.hide();
                }

                if (_this.padInitialised) {
                    _this.signaturePad.show();
                    return;
                }

                _this.signaturePad.jqSignature({
                    width: options.width,
                    height: options.height,
                    lineColor: options.lineColor,
                    autoFit: options.autoFit,
                    lineWidth: options.lineWidth,
                    border: options.border
                });

                _this.padInitialised = true;

                _this.signaturePad.on('jq.signature.changed', function() {
                    _this.useSignature();
                });

                $('body').on('click', function(event) {
                    if (_this.signaturePad.is(':hidden')) {
                        return;
                    }

                    if (!event.target.classList.contains('signature-pad-cancel')) {
                        _this.useSignature();
                    }
                });

                _this.signaturePad.show();
            },

            showSignaturePreview: function () {
                const _this = this;
                _this.previewImage.attr('src', _this.signatureInputField.val());
                _this.signaturePreview.show();
            },

            clearSignature: function () {
                const _this = this;
                _this.signaturePad.jqSignature('clearCanvas');
            },

            useSignature: function () {
                const _this = this;
                const dataUrl = _this.signaturePad.jqSignature('getDataURL');
                _this.signatureInputField.val(dataUrl);
            }
        };

        const signaturePad = $.extend(construct, {}, options);
        signaturePad.init();

        return $parent;
    };

}(jQuery));
